import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import api from 'services';

import { getRequestsTC } from 'actions/tc/requests';
import TextField from 'material-ui/TextField';
import { EhSelector } from 'components/Base/EhSelector/';
import IconButton from 'material-ui/IconButton';
import RaisedButton from 'material-ui/RaisedButton';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import { AutoComplete, DatePicker } from 'material-ui';
import TcRequestsItem from './Item';

const styles = {
    radioGroup: {
        margin: '20px 0',
    },
    radioButton: {
        display: 'inline-block',
        verticalAlign: 'middle',
        width: '25%',
    },
    paginationContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        padding: '.5em',
        fontSize: '.75em',
    },
    paginationSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paginationText: {
        margin: '0 1.25em',
    },
    paginationSelect: {
        width: 75,
        fontSize: '1em',
    },
    navigationLeft: {
        marginRight: '.5em',
        cursor: 'pointer',
    },
    navigationLeftFirstPage: {
        marginRight: '.5em',
        color: 'rgba(0,0,0,0.26)',
    },
    navigationRight: {
        margin: '0 .5em',
        cursor: 'pointer',
    },
    navigationRightLastPage: {
        margin: '0 .5em',
        color: 'rgba(0,0,0,0.26)',
    },
};

const getDefaultState = () => ({
    search: null,
    eh: [],
    delivery: {
        _id: null,
        name: null,
    },
    redelivery: {
        _id: null,
        name: null,
    },
    deliveryList: [],
    redeliveryList: [],
    readinessDate: null,
    cancellingDate: null,
    page: 1,
    limit: 50,
});

class TCRequestsList extends React.PureComponent {
    state = getDefaultState();

    componentDidMount() {
        this.props.getRequestsTC({});
    }

    changeField = (field, value) => {
        this.setState({
            [field]: value || null,
        });
    }

    handleEhChange = (eh) => {
        this.setState({
            ...this.state,
            eh,
        });
    }

    onChangeAutoComplete = (type, searchText) => {
        this.setState({
            [type]: { name: searchText },
        });

        if (searchText.length <= 2) {
            return;
        }

        api.findPortAdmin({ name: searchText, withAreas: true })
            .then((response) => {
                const portsList = [];
                response.data.data.forEach((port) => {
                    if (port.sub) {
                        port.sub.forEach((subPort) => {
                            portsList.push({
                                name: `${subPort.name} - country ${port.country.name}`,
                                item: subPort,
                            });
                        });
                    }

                    let name = '';
                    if (port.country) {
                        name = `${port.name} - country ${port.country.name}`;
                    } else {
                        name = port.name;
                    }

                    portsList.push({
                        name,
                        item: port,
                    });
                });

                this.setState({
                    [`${type}List`]: portsList,
                });
            })
            .catch(() => null);
    }

    onChooseAutoComplete = (type, updateProperties) => {
        if (!updateProperties) {
            return;
        }

        this.setState({
            [`${type}`]: {
                _id: updateProperties.item._id,
                name: updateProperties.name,
            },
        });
    }

    updateRows = () => {
        const { 
            page, limit, 
            readinessDate = undefined, cancellingDate = undefined, 
            delivery = undefined, redelivery = undefined, 
            eh, search = undefined, 
        } = this.state;

        const fromPublicMailParsers = [];
        const fromNonPublicMailParsers = [];
        
        eh.forEach((item) => {
            switch (item) {
            case 'fix':
            case 'varamar':
                fromPublicMailParsers.push(`${item}@shipnext.com`);
                break;
            case 'broker':
            case 'api':
                fromNonPublicMailParsers.push(item);
            default:
                break;
            }
        });
        
        this.props.getRequestsTC({
            page, 
            limit,
            filters: {
                search: search || undefined,
                eh,
                fromPublicMailParsers,
                fromNonPublicMailParsers,
                readinessDate,
                cancellingDate,
                delivery: delivery && delivery._id,
                redelivery: redelivery && redelivery._id,
            },
        });
    }

    handleSearch = () => {
        this.setState({
            page: 1,
        }, () => {
            this.updateRows();
        });
    }

    prevPage = () => {
        this.setState({
            page: this.props.tcRequestsResponse.previous,
        }, () => {
            this.updateRows();
        });
    }

    nextPage = () => {
        this.setState({
            page: this.props.tcRequestsResponse.next,
        }, () => {
            this.updateRows();
        });
    }

    handleClearFilters = () => {
        this.setState(
            getDefaultState(),
            () => {
                this.updateRows();
            },
        );
    }

    render() {
        const { 
            search,
            delivery, redelivery,
            deliveryList, redeliveryList,
            readinessDate, cancellingDate,
        } = this.state;

        const { tcRequests } = this.props;
        return (
            <div>
                <div className='filter'>
                    <div className='filter-row'>
                        <div className='search filter-column' style={{ width: '100%', justifyContent: 'space-between' }}>
                            <TextField
                                value={search || ''}
                                floatingLabelText='Search'
                                onChange={(e, value) => {
                                    this.changeField('search', value);
                                }}
                            />
                            <EhSelector values={this.state.eh} onChange={this.handleEhChange} />
                            <span style={{ display: 'flex', alignItems: 'center' }}>
                                <IconButton
                                    iconStyle={styles.navigationLeft}
                                    name='navigationLeft'
                                    onClick={this.prevPage}
                                >
                                    <ChevronLeft />
                                </IconButton>
                                <div className='item'>Page: {this.state.page}</div>
                                <IconButton
                                    iconStyle={styles.navigationRight}
                                    name='navigationRight'
                                    onClick={this.nextPage}
                                >
                                    <ChevronRight />
                                </IconButton>
                            </span>
                            <RaisedButton
                                label='Search'
                                style={{ fontSize: '13px', margin: '0 0 0 10px' }}
                                onClick={this.handleSearch}
                                primary
                            />
                            <RaisedButton
                                label='Clear filters'
                                style={{ fontSize: '13px', margin: '0 0 0 10px' }}
                                onClick={this.handleClearFilters}
                                primary
                            />
                        </div>
                    </div>
                    <div className='filter-row'>
                        <div className='filter-column paper-block'>
                            <div className='name-block absolute small-name'>Dates</div>
                            <DatePicker
                                onChange={(e, date) => { this.changeField('readinessDate', moment(date).format('MM-DD-YYYY')); }}
                                floatingLabelText='readinessDate'
                                formatDate={date => moment(date).format('MM-DD-YYYY')}
                                style={{ width: '75%' }}
                                textFieldStyle={{ width: '75%' }}
                                autoOk
                                value={readinessDate && new Date(readinessDate)}
                            />
                            <DatePicker
                                onChange={(e, date) => { this.changeField('cancellingDate', moment(date).format('MM-DD-YYYY')); }}
                                floatingLabelText='cancellingDate'
                                formatDate={date => moment(date).format('MM-DD-YYYY')}
                                style={{ width: '75%' }}
                                textFieldStyle={{ width: '75%' }}
                                autoOk
                                value={cancellingDate && new Date(cancellingDate)}
                                minDate={readinessDate ? new Date(readinessDate) : new Date()}
                            />
                        </div>
                        <div className='filter-column paper-block'>
                            <div className='name-block absolute small-name'>Del / Redel</div>
                            <AutoComplete
                                floatingLabelText='Delivery port'
                                searchText={delivery.name || ''}
                                dataSource={deliveryList}                                
                                dataSourceConfig={{ text: 'name', value: 'item' }}
                                onUpdateInput={val => this.onChangeAutoComplete('delivery', val)}
                                onNewRequest={val => this.onChooseAutoComplete('delivery', val)}
                                filter={AutoComplete.noFilter}
                                style={{ width: '75%' }}
                                textFieldStyle={{ width: '75%' }}

                                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                popoverProps={{
                                    canAutoPosition: true,
                                }}
                            />
                            <AutoComplete
                                floatingLabelText='Redelivery port'
                                searchText={redelivery.name || ''}
                                dataSource={redeliveryList}
                                dataSourceConfig={{ text: 'name', value: 'item' }}
                                onUpdateInput={val => this.onChangeAutoComplete('redelivery', val)}
                                onNewRequest={val => this.onChooseAutoComplete('redelivery', val)}
                                filter={AutoComplete.noFilter}
                                style={{ width: '75%' }}
                                textFieldStyle={{ width: '75%' }}

                                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                popoverProps={{
                                    canAutoPosition: true,
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div>
                    <ul className='list-requests'>
                        {
                            tcRequests && tcRequests.map(item => <TcRequestsItem key={item._id} item={item} />)
                        }
                    </ul>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        tcRequests: state.tcRequests.items,
        tcRequestsResponse: state.tcRequests,
        cargoTypes: state.cargoTypes,
    }),
    dispatch => bindActionCreators(
        {
            getRequestsTC,
        },
        dispatch,
    ),
)(TCRequestsList);



// WEBPACK FOOTER //
// ./app/components/TimeCharter/Requests/List.jsx